import { useRouter } from 'next/router';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import CompA from './CompA';
import CompB from './CompB';

export default function TheComp({ PRODUCT_BASE, PRODUCT_TM }: any) {
    const { pageStatus } = useProductStore();
    const { locale = 'us' } = useRouter();

    return (
        <div className="buy-content-12v">
            {['au'].includes(locale) && <CompB PRODUCT_BASE={PRODUCT_BASE} PRODUCT_TM={PRODUCT_TM} />}
            {!['au'].includes(locale) && (
                <>
                    {pageStatus === IPageStatus.statusA && <CompA />}
                    {pageStatus === IPageStatus.statusB && <CompB PRODUCT_BASE={PRODUCT_BASE} PRODUCT_TM={PRODUCT_TM} />}
                </>
            )}
        </div>
    );
}
